import { PreparationLotDto, CreatePreparationLotDto, UpdatePreparationLotDto, StartPreparationLotStepTimerDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { preparationLotService, PreparationLotsFilters } from '@services/PreparationLotService'
import { createAction, createAsyncThunk } from '@reduxjs/toolkit'

const getCurrentActivities = createAsyncThunk<Record<string, number | null>, string[]>(
  'preparationLot/getCurrentActivities',
  (ids) => preparationLotService.getCurrentActivities(ids)
)

const updatePreparationLot = createAsyncThunk<PreparationLotDto, { id: string; dto: UpdatePreparationLotDto }>(
  'preparationLot/update',
  ({ id, dto }) => preparationLotService.update(id, dto)
)

const startStepTimer = createAsyncThunk<PreparationLotDto, { preparationLotId: string; dto: StartPreparationLotStepTimerDto }>(
  'preparationLot/startStepTimer',
  ({ preparationLotId, dto }) => preparationLotService.startStepTimer(preparationLotId, dto)
)

const cancelStepTimer = createAsyncThunk<PreparationLotDto, { preparationLotId: string; timerId: string }>(
  'preparationLot/cancelStepTimer',
  ({ preparationLotId, timerId }) => preparationLotService.cancelStepTimer(preparationLotId, timerId)
)

const upsertPreparationLot = createAction<PreparationLotDto>('preparationLot/upsert')

const { reducer, actions, thunks } = baseCrudReducer<
  PreparationLotDto,
  CreatePreparationLotDto,
  UpdatePreparationLotDto,
  PreparationLotsFilters
>('preparationLot', preparationLotService, {
  extraReducers: (builder) => {
    builder.addCase(getCurrentActivities.fulfilled, (state, action) => {
      for (const [id, activityAtTimeMbq] of Object.entries(action.payload)) {
        const item = state.items.datas.find((lot) => lot.id === id)
        if (item) {
          item.activityAtTimeMbq = activityAtTimeMbq
        }
      }
    })
    const upsertLot = (state: any, action: { payload: PreparationLotDto }) => {
      const index = state.items.datas.findIndex((lot: PreparationLotDto) => lot.id === action.payload.id)
      if (index !== -1) {
        state.items.datas[index] = action.payload
      }
    }
    builder.addCase(updatePreparationLot.fulfilled, upsertLot)
    builder.addCase(startStepTimer.fulfilled, upsertLot)
    builder.addCase(cancelStepTimer.fulfilled, upsertLot)
    builder.addCase(upsertPreparationLot, upsertLot)
  },
})

export default reducer

export const { setFilters: setPreparationLotFilters } = actions

export const {
  getAll: getPreparationLots,
  create: createPreparationLot,
} = thunks

export { getCurrentActivities as getPreparationLotCurrentActivities, updatePreparationLot, startStepTimer, cancelStepTimer, upsertPreparationLot }
